const downloadCounts = require("npm-download-counts");
const version = require("./../../../node_modules/postcss-mesh/package.json")
  .version;

export default class StatsController {
  static PACKAGE = "postcss-mesh";
  static START = new Date("September 23, 2017 11:13:00");
  static END = new Date();

  constructor() {
    this.downloads = 0;
    this.downloadTargets = Array.from(
      document.querySelectorAll(".js-package-downloads")
    );
    this.versionTargets = Array.from(
      document.querySelectorAll(".js-package-version")
    );
    this.versionTargets.forEach(target => {
      target.innerHTML = `v${version}`;
    });

    downloadCounts(
      StatsController.PACKAGE,
      StatsController.START,
      StatsController.END,
      (err, data) => {
        data.forEach(day => {
          this.downloads += day.count;
        });

        this.downloadTargets.forEach(target => {
          target.innerHTML = this.downloads;
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./Components/StatsController.js